export default {
  date: 'Dátum',
  week: 'Týždeň',
  settings: 'Nastavenia kalendára:',
  createCalendar: 'Vytvoriť kalendár',
  createEvent: 'Vytvoriť udalosť',
  selectCalendar: 'Vybrať kalendár',
  publicCalendar: 'Verejný kalendár',
  calendarDesc: 'Pre verejný kalendár je potrebné zadať objednákové hodiny',
  selectColor: 'Vyberte farbu kalendára',
  assignedService: 'Priradená služba',
  type: {
    month: 'Mesačný kalendár',
    week: 'Týždenný kalendár',
    day: 'Denný kalendár'
  },
  bookingHours: {
    open: 'Otvára sa o',
    close: 'Zatvára sa o',
    closed: 'Zatvorené'
  },
  event: {
    add: 'Pridať udalosť',
    createdBy: 'Vytvoril',
    description: 'Popis',
    durationInMinutes: 'Trvanie v minútach',
    name: 'Názov udalosti',
    products: 'Úkony',
    searchAnimal: 'Vyhľadajte zviera a priradte ho k udalosti',
    startDate: 'Začiatok dátum',
    startTime: 'Začiatok čas',
    warning: 'Pozor čas Vašej udalosťi sa prekrýva s časom inej udalosti:'
  },
  status: {
    PROPOSED: 'Navrhnuté',
    CONFIRMED: 'Potvrdené',
    CANCELED: 'Zrušené',
    DELETED: 'Zmazané'
  },
  types: {
    REMINDER: 'Pripomienka',
    APPOINTMENT: 'Termín'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/sk/routes/calendar.js